import escape from "lodash/escape";

export const sanitizeHtml = (input: string): string => {
    const clean = (a: string) => {
        a = a.split("&nbsp;").join(" ");
        a = escape(a);
        return a;
    };

    const validTags = [
        { begin: /<strong>/, end: /<\/strong>/ },
        { begin: /<span class="rd_found" id="rd__jump">/, end: /<\/span>/ },
        {
            begin: /<span class="rd_found" style="background-color: #[0-9a-fA-F]{6};" id="rd__jump">/,
            end: /<\/span>/
        },
        { begin: /<span class="rd_found">/, end: /<\/span>/ },
        {
            begin: /<span class="rd_found" style="background-color: #[0-9a-fA-F]{6};">/,
            end: /<\/span>/
        }
    ];

    const tagStatuses = validTags.map(_ => ({
        inside: false
    }));

    const tagsLength = validTags.length;
    const outputs: string[] = [];
    let remaining = input;

    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    while (true) {
        const ltPos = remaining.indexOf("<");
        if (ltPos < 0) {
            // no tags left
            outputs.push(clean(remaining));
            break;
        }

        const rtPos = remaining.indexOf(">", ltPos);
        if (rtPos < 0) {
            // invalid html
            outputs.push(clean(remaining));
            break;
        }

        const leftOfTag = remaining.slice(0, ltPos);
        outputs.push(clean(leftOfTag));

        const tagContent = remaining.slice(ltPos, rtPos + 1).toLowerCase();
        remaining = remaining.slice(rtPos + 1);

        let tagIsValid = false;

        for (let i = 0; i < tagsLength; i++) {
            const tagStatus = tagStatuses[i];
            if (!tagStatus) {
                continue;
            }
            if (tagStatus.inside) {
                if (validTags[i]?.end.test(tagContent)) {
                    tagIsValid = true;
                    tagStatus.inside = false;
                }
            } else {
                if (validTags[i]?.begin.test(tagContent)) {
                    tagIsValid = true;
                    tagStatus.inside = true;
                }
            }
            if (tagIsValid) {
                break;
            }
        }

        if (tagIsValid) {
            outputs.push(tagContent);
        }
    }

    return outputs.join("");
};
